// TEMP-WRAPPER: this whole file exists only for the WebView wrapper app and
// is deleted when the app goes native.

type TinyAppHandshake = {
  commands?: string[];
  platform?: string;
  version?: string | null;
  build?: string | null;
};

declare global {
  interface Window {
    ReactNativeWebView?: { postMessage(message: string): void };
    __tinyApp?: TinyAppHandshake;
  }
}

// Injected only inside the app's WebView; __tinyApp lists the commands the
// installed build understands (app builds lag portal deploys).
export const isInMobileApp = () => 'ReactNativeWebView' in window;

export const sendMobileAppCommand = (
  kind: string,
  payload: Record<string, unknown>,
): boolean => {
  if (!window.ReactNativeWebView || !window.__tinyApp?.commands?.includes(kind)) {
    return false;
  }
  window.ReactNativeWebView.postMessage(JSON.stringify({ kind, payload }));
  return true;
};

export type MobileAppPlatform = 'ios' | 'android' | 'mobile_app';

export type MobileAppInfo = {
  platform: MobileAppPlatform;
  version?: string;
  build?: string;
};

const NATIVE_PLATFORMS: MobileAppPlatform[] = ['ios', 'android'];

export const getMobileAppInfo = (): MobileAppInfo | null => {
  if (!isInMobileApp()) return null;

  const app = window.__tinyApp;
  const platform = NATIVE_PLATFORMS.find(known => known === app?.platform);

  return {
    platform: platform ?? 'mobile_app',
    version: app?.version ?? undefined,
    build: app?.build ?? undefined,
  };
};
